
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import Radio from 'backbone.radio';
import template from '@/../templates/login-key.hbs';


    var globalCh = Radio.channel('global');

    var LoginKeyItemView = Marionette.View.extend({
        tagName: 'li',
        template: Handlebars.compile(template),
        className: "col-sm-12 login-key",
        ui: {
            delete: '.actions .delete',
            edit: '.actions .settings',
        },
        events: {
            'click @ui.delete': 'delete_login_key',
            'click @ui.edit': 'edit_login_key',
        },
        delete_login_key: function () {
            return globalCh.request(
                'show_delete_login_key_dialog',
                this.model
            );
        },
        edit_login_key: function() {
            return globalCh.request(
                'show_edit_login_key_dialog',
                this.model
            );
        },
    });

    export default LoginKeyItemView;
